import { LoadingOutlined } from "@ant-design/icons";
import React,{ useEffect,useState } from "react";
import successIcon from "../../../assets/images/autozones/check_circle.svg";
import errorIcon from "../../../assets/images/autozones/error_outline.svg";
import retryIcon from "../../../assets/images/autozones/icon-left.svg";

import { Spin } from "antd";
import "../../autozones/styles.less";
import { useNewTrialState } from "../../new-trail/hooks/NewTrialStateProvider";
import { AUTOZONE_REQUEST_STATUS } from "../types";
type LoaderType = "processing" | "error" | "success";

interface LoaderProps {
  type: LoaderType;
}

const ZoneLoadingStatus: React.FC<LoaderProps> = ({ type }) => {
  const { autozoneRequestStatus } = useNewTrialState();
  const [showSuccess, setShowSuccess] = useState(true);

  useEffect(() => {
    if (autozoneRequestStatus === AUTOZONE_REQUEST_STATUS.SUCCESS) {
      setShowSuccess(true);
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    } else {
      setShowSuccess(true);
    }
  }, [autozoneRequestStatus]);

  switch (autozoneRequestStatus) {
    case AUTOZONE_REQUEST_STATUS.LOADING:
      return <ProcessingTooltip />;
    case AUTOZONE_REQUEST_STATUS.ERROR:
      return <ErrorTooltip />;
    case AUTOZONE_REQUEST_STATUS.SUCCESS:
      return showSuccess ? <SuccessTooltip /> : null;
    default:
      return null;
  }
};

const ProcessingTooltip: React.FC = () => (
  <div className="autozone-loading-status">
    <span>
      <Spin
        indicator={
          <LoadingOutlined
            spin
            style={{ fontSize: 24, color: "rgba(0, 146, 228, 1)" }}
            twoToneColor="#dfe2e7"
          />
        }
      />
    </span>
    <span>Autozone is being generated</span>
  </div>
);

const ErrorTooltip: React.FC = () => {
  const { setAutozoneRequestStatus } = useNewTrialState();
  const handleRetry = (): void => {
    setAutozoneRequestStatus(AUTOZONE_REQUEST_STATUS.RETRY);
  };
  return (
    <div className="autozone-loading-status">
      <img src={errorIcon} alt="service-btn" />
      <div>Error While Generating Autozone</div>
      <div className="try-again-text" onClick={handleRetry}>
        <img src={retryIcon} alt="service-btn" />
        Try Again
      </div>
    </div>
  );
};

const SuccessTooltip: React.FC = () => (
  <div className="autozone-loading-status">
    <img src={successIcon} alt="service-btn" />
    <div>Autozone generated successfully</div>
  </div>
);

export default ZoneLoadingStatus;
